import { configureStore } from "@reduxjs/toolkit";
import {eventReducer} from '../redux/event';

export default configureStore({
  reducer: {
    event: eventReducer,
  }
})
